import type { Event } from 'models';
import { Modal } from 'ui';
import { EventInviteesForm } from './event-invitees-form';

type P = {
  className?: string;
  event: Event;
  isOpened: boolean;
  onClose: () => void;
  onOpenInviteModal?: () => void;
};

const ReminderInviteesModal = ({ className, event, isOpened, onClose, onOpenInviteModal }: P) => (
  <Modal
    className={className}
    isOpened={isOpened}
    maskProps={{
      closable: false,
    }}
    onCancel={() => {
      onClose();
    }}
    title="All people"
    width="medium"
  >
    <Modal.ScrollableContent paddingBottom={false} paddingTop={false}>
      <EventInviteesForm event={event} onCancel={onClose} onOpenInviteModal={onOpenInviteModal} />
    </Modal.ScrollableContent>
  </Modal>
);

export default ReminderInviteesModal;
